/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three';
import React, { useMemo } from 'react';
import { useThree } from '@react-three/fiber';

import { const_var, params } from '../../../../../../../redux/reducers/reducer';
import { delModel, extrudeSettings, roofPattern, textureAnisotropy } from '../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../assets/libs/csg-lib';
import { MaterialOuterWallNew, MaterialWainScotWallNew } from '../../../../../CustomMaterial';

const OutsideWallModel = () => {
    const { gl } = useThree();

    const canvasElement = document.getElementsByClassName("buildingcanvas")
    const isPattern = (canvasElement != undefined && canvasElement[0]?.clientWidth > 1050 && !params.p_v_w) ? true : false
    
       const texture = useMemo(() => {
           let texture = (const_var.wallTextureObj[params.wallTexture] != undefined) ? const_var.wallTextureObj[params.wallTexture].clone() : const_var.wallTextureObj[params.wallTexture];
           let repeatX = 1.3
           let repeatY = 1.3
           switch (params.wallTexture) {
               case 'wood_siding':
                   repeatX = 0.15
                   repeatY = 0.15
                   break;
               case 'lap_siding':
                   repeatY = 0.3
                   break;
               case 'board_and_batten_siding':
                   repeatX = 0.75
                   break;
               case 'stackstone_ash_siding':
               case 'stackstone_shadow_siding':
               case 'stackstone_smoke_siding':
                   repeatX = 0.2
                   repeatY = 0.2
                   break;
               case 'real_tree_siding':
               case 'brick_siding':
               case 'stone_siding':
                   repeatX = 0.22
                   repeatY = 0.27
                   break;
               case 'camo_siding':
                   repeatX = 0.22
                   repeatY = 0.1
                   break;
               default :
                   repeatX = 1.3
                   repeatY = 1.3
                   break
           }
           textureAnisotropy(gl, texture,repeatX, repeatY, Math.PI/-2);
           return texture
       }, [params.p_v_w,params.wallTexture,const_var.wallTextureObj[params.wallTexture]])
    // const texture = const_var.wallTextureObj[params.wallTexture]

    const rightWallModel = useMemo(() => {
        let model = new THREE.Shape();
        model.moveTo(-(params.p_d / 2 + 0.15), (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) - 0.001 : params.p_h - 0.001);
        model.lineTo(-params.p_d / 2 + parseInt(params.p_u_t) + 0.02, (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) - 0.001 : params.p_h - 0.001);
        model.lineTo(-params.p_d / 2 + parseInt(params.p_u_t) + 0.02,0);
        model.lineTo(-(params.p_d / 2 + 0.15), 0);
        model.closePath()

        return model;
    }, [params.p_d, params.singleSlope, params.freeStandingSide, parseInt(params.p_u_t), params.p_w, params.p_h, params.p_r_p])
    
    const mainWallModel = useMemo(() => {
        
        let verticalHorizontalPos = {"x": params.p_w / 2 + 0.005,"y" : ((params.p_w_c_n && (params.p_r_w === 'Close' || params.p_u_c)) ? 2.935 : 0), "z" : params.p_d / 2 + 0.15}
        let verticalHorizontalRot = {"x":0,"y" : Math.PI,"z" : Math.PI / 2}
        let patternLength = params.p_h - 0.01 + ((params.p_w_c_n && (params.p_r_w === 'Close' || params.p_u_c)) ? -2.935 : 0)
        let patternDepth = params.p_d + 0.3
        
        const meshWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLength, isPattern), extrudeSettings(patternDepth)))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('right', 'wall'), extrudeSettings(1)))
        const meshWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(rightWallModel, extrudeSettings(1)))
    
        let meshWallModel_Temp = meshWallModel.clone();
        meshWallModel_Temp.position.set(verticalHorizontalPos.x,verticalHorizontalPos.y,verticalHorizontalPos.z);
        meshWallModel_Temp.rotation.set(verticalHorizontalRot.x,verticalHorizontalRot.y,verticalHorizontalRot.z);
        meshWallModel_Temp.updateMatrixWorld();
    
        let meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(params.p_w / 2 + 0.5, 0, -params.endStoragePositionZ);
        meshDelModel_Temp.rotation.set(0,Math.PI / -2,0)
        meshDelModel_Temp.updateMatrixWorld();
    
        let meshWallDelModel_Temp = meshWallDelModel.clone();
        meshWallDelModel_Temp.position.set(params.p_w / 2 + 0.5, 0, 0);
        meshWallDelModel_Temp.rotation.set(0,Math.PI / -2,0)
        meshWallDelModel_Temp.updateMatrixWorld();
    
        const meshWallModel_CSG = CSG.fromMesh(meshWallModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const meshWallDelModel_CSG = CSG.fromMesh(meshWallDelModel_Temp);
    
        const wallModel_CSG = meshWallModel_CSG.subtract(meshDelModel_CSG);
        const meshWallDel_CSG = wallModel_CSG.intersect(meshWallDelModel_CSG);
        const CSGWallModel = CSG.toMesh(meshWallDel_CSG,new THREE.Matrix4())
    
        /************** cutting hole in wainscot using CSG ***************/

        // let verticalHorizontalWaingscotPos = (params.wallTexture == "vertical") ? {"x":params.p_w / 2 + 0.005,"y": 0, "z": -params.p_d / 2 - 0.15 } : {"x": params.p_w / 2 + 0.005,"y" : 0, "z" : params.p_r_w === 'Close' ? params.p_d / 2 + 0.15: -params.p_d / 2 + parseInt(params.p_u_t) }
        // let verticalHorizontalWaingscotRot = (params.wallTexture == "vertical") ? {"x":Math.PI / -2,"y" : 0,"z" : Math.PI / -2} : {"x":0,"y" : Math.PI,"z" : Math.PI / 2}
        let wainscotVerticalHorizontalPos = {"x": params.p_w / 2 + 0.005,"y" : 0, "z" : params.p_d / 2 + 0.15}
        let wainscotVerticalHorizontalRot = {"x":0,"y" : Math.PI,"z" : Math.PI / 2}
        let lengthPattern = 3
        let depthPattern = params.p_d + 0.3
    
        const meshWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPattern, isPattern), extrudeSettings(depthPattern)))
        let meshWainscotModel_Temp = meshWainscotModel.clone();
        meshWainscotModel_Temp.position.set(wainscotVerticalHorizontalPos.x,wainscotVerticalHorizontalPos.y,wainscotVerticalHorizontalPos.z);
        meshWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRot.x,wainscotVerticalHorizontalRot.y,wainscotVerticalHorizontalRot.z);
        meshWainscotModel_Temp.updateMatrixWorld();
    
        const meshWainscotModel_CSG = CSG.fromMesh(meshWainscotModel_Temp);
    
        const wainscotModel_CSG = meshWainscotModel_CSG.subtract(meshDelModel_CSG);
        const wainscotModelCSG = wainscotModel_CSG.intersect(meshWallDelModel_CSG);
        const CSGWainscotModel = CSG.toMesh(
            wainscotModelCSG,
            new THREE.Matrix4()
        )

        return {
            wall: CSGWallModel.geometry,
            wainScot: CSGWainscotModel.geometry
        }
    
    }, [params.wallTexture, params.endStoragePositionZ, params.p_d, params.p_h, params.p_w, params.p_r_p, params.p_u_c, parseInt(params.p_u_t),params.singleSlope, params.p_w_c_n, const_var.newDoorsArray, params.p_v_w, params.p_r_w])

    return (
        <>
            {mainWallModel.wall &&
                <mesh name="c_b_r_s_w" geometry={mainWallModel.wall} >
                    <MaterialOuterWallNew isPattern={isPattern} texture={texture} visibleSection={"center"} />
                </mesh>
            }

            {(params.p_w_c_n === true ) && mainWallModel.wainScot &&
                <mesh name="c_b_r_s_w_wainscot" geometry={mainWallModel.wainScot} position={[0.005, 0, 0]}>
                    <MaterialWainScotWallNew isPattern={isPattern} texture={texture} visibleSection={"center"} />
                </mesh>
            }
        </>
    )
}

export default OutsideWallModel